export function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20webtoon%20style%20illustration%20with%20vibrant%20warm%20orange%20coral%20and%20soft%20cream%20gradient%2C%20dynamic%20flowing%20lines%2C%20stylized%20dramatic%20composition%2C%20modern%20digital%20art%20with%20bold%20color%20blocks%2C%20clean%20minimal%20background%20with%20geometric%20shapes%2C%20no%20text%2C%20cinematic%20feel%2C%20high%20contrast%2C%20inspiring%20and%20energetic%20mood&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
        alt="韩漫网 - 韩漫画免费全集在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
        fetchpriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 tracking-wide">
            韩漫网
          </h1>
          <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
            韩漫画免费阅读平台 · 韩漫全集大全 · 漫画下拉式无广告
          </p>
          <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto mb-8 leading-relaxed">
            来到韩漫网，您将免费阅读全集的韩漫大全，随时随地畅享各种漫画内容
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/category/all"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium hover:bg-primary-600 transition-colors text-sm md:text-base whitespace-nowrap"
            >
              立即阅读
            </a>
            <a
              href="/category/romance"
              className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium hover:bg-white/20 transition-colors text-sm md:text-base whitespace-nowrap"
            >
              恋爱漫画
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-primary-500"></div>
        <div className="w-2 h-2 rounded-full bg-white/40"></div>
        <div className="w-2 h-2 rounded-full bg-white/40"></div>
      </div>
    </section>
  );
}